import generateZonesPlaceholder from '../../images/generate-zones-placeholder.png';
import drawZonesPlaceholder from '../../images/draw-your-own-placeholder.png';
import usePreviousPrescriptionPlaceholder from '../../images/use-previous-prescription-zones-placeholder.png';
import importedZonesPlaceholder from '../../images/imported-zones-placeholder.png';

export default {
  generateZonesPlaceholder,
  drawZonesPlaceholder,
  usePreviousPrescriptionPlaceholder,
  importedZonesPlaceholder
};
